export default class VideoCardModel {
  constructor({
    video_title: title,
    video_url: url,
    video_published_date: date,
    video_source: source,
  } = {}) {
    this.title = title;
    this.url = url;
    this.date = date;
    this.source = source;
  }

  getTitle() {
    return this.title;
  }

  getUrl() {
    return this.url;
  }

  getPublicationDate() {
    return this.date;
  }

  getSource() {
    return this.source;
  }
}
